"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
let ActionDetails = class ActionDetails extends vue_property_decorator_1.Vue {
    get allTimes() {
        const dataArray = this.summaryConfigData.configuration.locations;
        const uniqueTimesObject = {};
        dataArray.forEach((item) => {
            if (item.treatments && Array.isArray(item.treatments)) {
                item.treatments.forEach((treatment) => {
                    if (treatment.times && Array.isArray(treatment.times)) {
                        treatment.times
                            .filter((time) => time.time !== 0)
                            .forEach((time) => {
                            uniqueTimesObject[time.time] = time;
                        });
                    }
                });
            }
        });
        const uniqueTimesArray = Object.values(uniqueTimesObject);
        return uniqueTimesArray;
    }
    get allLocations() {
        const locations = this.summaryConfigData.configuration.locations;
        return locations;
    }
    get version() {
        const locations = this.summaryConfigData.metadata.version;
        return locations;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ActionDetails.prototype, "project", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ActionDetails.prototype, "summaryConfigData", void 0);
ActionDetails = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            List: bmk_ui_framework_1.List,
            ListItem: bmk_ui_framework_1.ListItem,
            DateStylized: bmk_ui_framework_1.DateStylized,
        },
    })
], ActionDetails);
exports.default = ActionDetails;
